const ADOPTED_STATUS = 'adopted'
const IN_PROGRESS_STATUS = 'in_progress'
const INACTIVE_STATUS = 'inactive'
const OVERDUE_STATUS = 'overdue'
const PENDING_STATUS = 'pending'
const RISK_ASSUMED_STATUS = 'risk_assumed'
const TREATED_STATUS = 'treated'
const WAITING_ANSWER_STATUS = 'waiting_answer'

const STATUS_IDS = {
  ADOPTED_STATUS,
  IN_PROGRESS_STATUS,
  INACTIVE_STATUS,
  OVERDUE_STATUS,
  PENDING_STATUS,
  RISK_ASSUMED_STATUS,
  TREATED_STATUS,
  WAITING_ANSWER_STATUS,
}

const ADOPTED_STATUS_LABEL = 'Adotado'
const IN_PROGRESS_STATUS_LABEL = 'Em andamento'
const INACTIVE_STATUS_LABEL = 'Inativo'
const OVERDUE_STATUS_LABEL = 'Atrasado'
const PENDING_STATUS_LABEL = 'Pendente'
const RISK_ASSUMED_STATUS_LABEL = 'Risco assumido'
const TREATED_STATUS_LABEL = 'Tratado'
const WAITING_ANSWER_STATUS_LABEL = 'Aguardando resposta'

const STATUS_LABELS = {
  ADOPTED_STATUS_LABEL,
  IN_PROGRESS_STATUS_LABEL,
  INACTIVE_STATUS_LABEL,
  OVERDUE_STATUS_LABEL,
  PENDING_STATUS_LABEL,
  RISK_ASSUMED_STATUS_LABEL,
  TREATED_STATUS_LABEL,
  WAITING_ANSWER_STATUS_LABEL,
}

const INITIAL_PLAN_STATUS = 'initial'
const HEADWAY_PLAN_STATUS = 'headway'
const CONCLUSION_PLAN_STATUS = 'conclusion'

const PLAN_ACTION_KIND = 'plan_action'
const EVIDENCE_KIND = 'evidence'

const KIND = {
  ALL: 'all',
  BASIC_REQUIREMENT: 'Requisitos Fundamentais',
  GOVERNANCE_CULTURE: 'Governança e Cultura',
  INFRASTRUCTURE_TECHNOLOGY: 'Infraestrutura e Tecnologia',
  JURIDIC: 'Jurídico',
}

const KIND_OPTIONS = [
  { id: KIND.BASIC_REQUIREMENT, name: 'Requisitos Fundamentais' },
  { id: KIND.GOVERNANCE_CULTURE, name: 'Governança e Cultura' },
  {
    id: KIND.INFRASTRUCTURE_TECHNOLOGY,
    name: 'Infraestrutura e Tecnologia',
  },
  { id: KIND.JURIDIC, name: 'Jurídico' },
]

const STATUSES = [
  { id: PENDING_STATUS, name: PENDING_STATUS_LABEL },
  { id: IN_PROGRESS_STATUS, name: IN_PROGRESS_STATUS_LABEL },
  { id: WAITING_ANSWER_STATUS, name: WAITING_ANSWER_STATUS_LABEL },
  { id: OVERDUE_STATUS, name: OVERDUE_STATUS_LABEL },
  { id: TREATED_STATUS, name: TREATED_STATUS_LABEL },
  { id: ADOPTED_STATUS, name: ADOPTED_STATUS_LABEL },
  { id: RISK_ASSUMED_STATUS, name: RISK_ASSUMED_STATUS_LABEL },
]

const ENABLE_ALERT = [ADOPTED_STATUS, IN_PROGRESS_STATUS, TREATED_STATUS]
const FINALIZED_ACTION = [IN_PROGRESS_STATUS, TREATED_STATUS, OVERDUE_STATUS]
const RISK_ACTION = [
  RISK_ASSUMED_STATUS,
  OVERDUE_STATUS,
  IN_PROGRESS_STATUS,
  PENDING_STATUS,
]
const ADOPTED_MEASURES = [ADOPTED_STATUS, TREATED_STATUS]

const QUESTION_CONTROL_DRIVER_STEP_1 = 'question-control-driver-step-1'
const QUESTION_CONTROL_DRIVER_STEP_2 = 'question-control-driver-step-2'
const QUESTION_CONTROL_DRIVER_STEP_3 = 'question-control-driver-step-3'
const QUESTION_CONTROL_DRIVER_STEP_4 = 'question-control-driver-step-4'
const QUESTION_CONTROL_DRIVER_STEP_5 = 'question-control-driver-step-5'
const QUESTION_CONTROL_DRIVER_STEP_6 = 'question-control-driver-step-6'
const QUESTION_CONTROL_DRIVER_STEP_7 = 'question-control-driver-step-7'
const QUESTION_CONTROL_DRIVER_STEP_8 = 'question-control-driver-step-8'

const QUESTION_CONTROL_DRIVER_STEP_OBJECT_5 = {
  element: '#' + QUESTION_CONTROL_DRIVER_STEP_5,
  popover: {
    title: 'Risco Assumido',
    description:
      'A empresa aceita o risco, fornecendo uma justificativa para a ação, visível em "informações". É possível ver o horário e o usuário que aceitou o risco. É possível dar continuidade com o tratamento do risco em "reabrir".',
  },
}

const QUESTION_CONTROL_DRIVER_STEP_OBJECT_6 = {
  element: '#' + QUESTION_CONTROL_DRIVER_STEP_6,
  popover: {
    title: 'Tratado',
    description: 'Ao finalizar um controle esse é o status definido.',
  },
}

const QUESTION_CONTROL_DRIVER_STEP_OBJECT_7 = {
  element: '#' + QUESTION_CONTROL_DRIVER_STEP_7,
  popover: {
    title: 'Adotado',
    description:
      'Aparece quando uma questão é respondida com <strong>SIM</strong>, com isso você pode "visualizar" ou "reabrir" adicionando ou editando evidências da implantação.',
  },
}

const QUESTION_CONTROL_DRIVER_STEP_OBJECT_8 = {
  element: '#' + QUESTION_CONTROL_DRIVER_STEP_8,
  popover: {
    title: 'Pendente',
    description:
      'Aparece para questões com respostas <strong>NÃO</strong> e <strong>PARCIAL</strong>, é possível "visualizar", "editar" ou "assumir o risco".',
  },
}

const QUESTION_CONTROL_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + QUESTION_CONTROL_DRIVER_STEP_1,
    popover: {
      description:
        'As Medidas de Segurança são associadas aos questionários respondidos como, Sim, Parcial e Não.',
    },
  },
  {
    element: '#' + QUESTION_CONTROL_DRIVER_STEP_2,
    popover: {
      description:
        'Também é possível cadastrar uma nova medida de forma livre, como por exemplo: Firewall IDS/IPS, Câmeras de Segurança.',
    },
  },
  {
    element: '#' + QUESTION_CONTROL_DRIVER_STEP_3,
    popover: {
      description:
        'Na medida de segurança, você encontra um passo a passo detalhado sobre como preencher as medidas de segurança corretamente. Logo abaixo, há um filtro por status que mostra o que precisa ser feito. Por exemplo, o filtro pode indicar as medidas que estão aguardando resposta, é necessário ir em questionários e respondê-los antes de prosseguir. ',
    },
  },
  {
    element: '#' + QUESTION_CONTROL_DRIVER_STEP_4,
    popover: {
      description:
        'Edite a medida de segurança, atribua responsáveis e um plano de ação, inclua evidências e mais informações. O campo de evidências será disponibilizado ao adicionar um plano de ação.',
    },
  },
]

const QUESTION_DRIVER_STATUS_ID = {
  [RISK_ASSUMED_STATUS]: QUESTION_CONTROL_DRIVER_STEP_5,
  [TREATED_STATUS]: QUESTION_CONTROL_DRIVER_STEP_6,
  [ADOPTED_STATUS]: QUESTION_CONTROL_DRIVER_STEP_7,
  [PENDING_STATUS]: QUESTION_CONTROL_DRIVER_STEP_8,
}

const QUESTION_DRIVER_SELECTED_STEPS = {
  [RISK_ASSUMED_STATUS]: QUESTION_CONTROL_DRIVER_STEP_OBJECT_5,
  [TREATED_STATUS]: QUESTION_CONTROL_DRIVER_STEP_OBJECT_6,
  [ADOPTED_STATUS]: QUESTION_CONTROL_DRIVER_STEP_OBJECT_7,
  [PENDING_STATUS]: QUESTION_CONTROL_DRIVER_STEP_OBJECT_8,
}

const QUESTION_CONTROL_EDIT_DRIVER_STEP_1 =
  'question-control-edit-driver-step-1'
const QUESTION_CONTROL_EDIT_DRIVER_STEP_2 =
  'question-control-edit-driver-step-2'

const QUESTION_CONTROL_EDIT_DRIVER_STEP_OBJECT_1 = {
  element: '#' + QUESTION_CONTROL_EDIT_DRIVER_STEP_1,
  popover: {
    description:
      'Edite uma medida de segurança <strong>Pendente</strong> ou <strong>Em Andamento</strong>, adicione um plano de ação e atribua um responsável com prazos definidos. Se necessário, utilize a DAI para sugerir planos adequados. Após salvar, o campo de evidências será habilitado para armazenar as provas de implementação. Finalize o processo ao concluir a etapa de evidências.',
  },
}

const QUESTION_CONTROL_EDIT_DRIVER_STEP_OBJECT_2 = {
  element: '#' + QUESTION_CONTROL_EDIT_DRIVER_STEP_2,
  popover: {
    description:
      'Reabra uma medida de segurança <strong>Adotado</strong> ou Finalizado, para editar as evidências.',
  },
}

const SECOND_STEP_ANSWER_ITEMS = [
  IN_PROGRESS_STATUS,
  OVERDUE_STATUS,
  RISK_ASSUMED_STATUS,
  ADOPTED_STATUS,
  WAITING_ANSWER_STATUS,
]

const LEVEL_CONFIGS = {
  1: {
    title: 'Etapa 1: Termine os questionários',
    concludedDescription: [
      'Parabéns! Todos os questionários foram respondidos com sucesso.',
      'Você está pronto para avançar e tratar as medidas de segurança identificadas.',
      'Continue acompanhando e revisando periodicamente para garantir que todas as informações estejam sempre atualizadas.',
    ],
    description: [
      'Percebi que a organização ainda não concluiu os Questionários.',
      'Você deve voltar na aba anterior e responder todas as perguntas com base na realidade da sua organização antes de avançar.',
      'Caso queira, você pode avançar a etapa e trabalhar nas Medidas de Segurança apenas para as questões que já foram respondidas.',
    ],
  },
  2: {
    title: 'Etapa 2: Trate as medidas de segurança pendentes',
    concludedDescription: [
      'Excelente! Todas as medidas de segurança pendentes foram tratadas.',
      'Agora você pode avançar para o próximo passo: finalizar o tratamento das medidas de segurança.',
      'Continue monitorando e atualizando as ações conforme necessário para manter a conformidade.',
    ],
    descriptionListContent:
      'Agora que você concluiu os Questionários, é hora de avançar para o próximo passo: tratar as medidas de segurança pendentes.',
    descriptionListItems: [
      'Edite e inclua um plano de ação para que o controle seja adotado.',
      'Clique nos três pontinhos na coluna Ações, ou clique em “Assumir o risco” e justifique por que ele não será implementado.',
    ],
  },
  3: {
    title: 'Etapa 3: Finalize e anexe evidências',
    descriptionListContent:
      'Parabéns por chegar até aqui! Agora é o momento de concluir o ciclo das medidas de segurança.',
    descriptionListItems: [
      'Anexe as evidências de implementação para as medidas com status "Adotada".',
      'Finalize o tratamento das demais medidas, vinculando os respectivos planos de ação.',
    ],
  },
}

const questionControl = {
  ADOPTED_MEASURES,
  ADOPTED_STATUS,
  CONCLUSION_PLAN_STATUS,
  ENABLE_ALERT,
  EVIDENCE_KIND,
  FINALIZED_ACTION,
  HEADWAY_PLAN_STATUS,
  IN_PROGRESS_STATUS,
  INACTIVE_STATUS,
  INITIAL_PLAN_STATUS,
  KIND_OPTIONS,
  KIND,
  OVERDUE_STATUS,
  PENDING_STATUS,
  PLAN_ACTION_KIND,
  QUESTION_CONTROL_DRIVER_STEP_1,
  QUESTION_CONTROL_DRIVER_STEP_2,
  QUESTION_CONTROL_DRIVER_STEP_3,
  QUESTION_CONTROL_DRIVER_STEP_4,
  QUESTION_CONTROL_DRIVER_STEPS_OBJECT,
  QUESTION_CONTROL_EDIT_DRIVER_STEP_1,
  QUESTION_CONTROL_EDIT_DRIVER_STEP_2,
  QUESTION_CONTROL_EDIT_DRIVER_STEP_OBJECT_1,
  QUESTION_CONTROL_EDIT_DRIVER_STEP_OBJECT_2,
  QUESTION_DRIVER_SELECTED_STEPS,
  QUESTION_DRIVER_STATUS_ID,
  ADOPTED_STATUS_LABEL,
  IN_PROGRESS_STATUS_LABEL,
  INACTIVE_STATUS_LABEL,
  OVERDUE_STATUS_LABEL,
  PENDING_STATUS_LABEL,
  RISK_ACTION,
  RISK_ASSUMED_STATUS_LABEL,
  RISK_ASSUMED_STATUS,
  STATUSES,
  TREATED_STATUS_LABEL,
  TREATED_STATUS,
  WAITING_ANSWER_STATUS_LABEL,
  WAITING_ANSWER_STATUS,
  STATUS_IDS,
  STATUS_LABELS,
  SECOND_STEP_ANSWER_ITEMS,
  LEVEL_CONFIGS,
}

export default questionControl
